/**
 * Mapping between SportsDataAPI oddStyle notation and legacy one
 */
export var OddStyles;
(function (OddStyles) {
    OddStyles[OddStyles["american"] = 0] = "american";
    OddStyles[OddStyles["decimal"] = 1] = "decimal";
    OddStyles[OddStyles["fractional"] = 2] = "fractional";
    OddStyles[OddStyles["hk"] = 3] = "hk";
    OddStyles[OddStyles["malay"] = 4] = "malay";
    OddStyles[OddStyles["indo"] = 5] = "indo";
})(OddStyles || (OddStyles = {}));
//# sourceMappingURL=OddStyles.js.map